import { c as _c } from "react/compiler-runtime";
import { memo, type PropsWithChildren, type ReactNode } from 'react';
function SubSectionTitle(t0) {
  const $ = _c(3);
  const {
    children,
    id
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== id) {
    t1 = <span className="text-foreground text-sm" id={id}>{children}</span>;
    $[0] = children;
    $[1] = id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export default memo(SubSectionTitle);